import {
  booleanAttribute,
  Component,
  computed,
  contentChild,
  contentChildren,
  Directive,
  effect,
  inject,
  input,
  signal
} from '@angular/core';
import {NgTemplateOutlet} from '@angular/common';
import {ContentTemplateDirective} from '../content-template.directive';
import {Title} from '@angular/platform-browser';
import {PageTabDirective} from './page-tab.directive';
import {IconComponent} from '../icon/icon.component';
import {ActivatedRoute, ParamMap, RouterLink} from '@angular/router';
import {toSignal} from '@angular/core/rxjs-interop';
import {IconType} from '../../icons';

@Directive({selector: '[pageHeading]'})
export class PageHeaderDirective extends ContentTemplateDirective {
}

@Directive({selector: '[pageHeadingButtons]'})
export class PageHeaderButtonsDirective extends ContentTemplateDirective {
}

@Directive({selector: '[pageFooter]'})
export class PageFooterDirective extends ContentTemplateDirective {
}

@Component({
  selector: 'app-page',
  imports: [
    NgTemplateOutlet,
    IconComponent,
    RouterLink
  ],
  templateUrl: './page.component.html',
  styleUrls: ['./page.component.scss'],
  host: {
    class: 'app-column hh-fill gapped tight'
  }
})
export class PageComponent {
  readonly heading = input<string | null>(null)
  readonly pageTitle = input<string | null>(null)
  readonly pageIcon = input<IconType | null>(null)
  readonly loading = input<boolean, any>(false, { transform: booleanAttribute })

  protected readonly headingTemplate = contentChild(PageHeaderDirective)
  protected readonly headingButtonsTemplate = contentChild(PageHeaderButtonsDirective)
  protected readonly footerTemplate = contentChild(PageFooterDirective)
  protected readonly titleService = inject(Title)
  protected readonly tabs = contentChildren(PageTabDirective)
  protected readonly activeTab = computed(() => {
    const tabId = this.activeTabId()
    return tabId ? this.tabs()?.find(t => t.tabId() === tabId) : this.tabs()[0]
  })

  private readonly route = inject(ActivatedRoute)
  private readonly params = toSignal(this.route.queryParamMap)
  private readonly activeTabId = computed(() => {
    return this.params()?.get('tab') || null
  })

  constructor() {
    effect(() => {
      const title = this.pageTitle() || this.heading()
      if (title) {
        this.titleService.setTitle(title + ' - Sysprompthub')
      } else {
        this.titleService.setTitle('Sysprompthub')
      }
    })

    effect(() => {
      const activeTab = this.activeTab()
      if (activeTab && !activeTab.rendered()) {
        activeTab.rendered.set(true)
      }
    })
  }
}
